import { Box, Tooltip } from '@mui/material';

const CustomTooltip = ({ children, label, ...props }) => {
    return (
        <Tooltip
            title={label}
            PopperProps={{
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 8], // espacio entre el tooltip y el elemento
                        },
                    },
                ],
            }}
            slotProps={{
                tooltip: {
                    sx: {
                        bgcolor: 'background.darkCard', // fondo (por ejemplo, gris oscuro)
                        color: 'text.primary', // texto blanco
                        border: '1px solid',
                        borderColor: 'border.main',
                        fontSize: 13,
                        px: 1.5,
                        py: 0.75,
                        borderRadius: 1,
                        boxShadow: 2,
                    },
                },
            }}
            arrow
            {...props}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;
